/**
 * Crea un arreglo con las manos de los jugadores
 * @param {*} scene - Escena actual de Phaser
 */
export function crearManosJugadores(scene) {
  scene.colJugadores = [
    [-1, null, "Dealer"],
    [1, null, "Jugador 1"],
  ];
}

/*
  ESTRUCTURA ARREGLO COLJUGADORES
  colJugadores = [dealer, jugador1]
  jugador1 = [id, colManosJugador1, nombreJugador]
  colManosJugador = [mano1Jugador1, mano2Jugador1]
  mano1Jugador1 = [colCartasJugador1, valorCartas, apuestaTotal, recompensa, ejeXproxCarta, ejeYproxCarta, resultado, seguro, recompensaSeguro, descripcion]
  colCartasJugador1 = [carta1, carta2, carta3]
  carta1Jugador1 = [id, valor, palo, descripcion, imagen]

  Acceso a imagen:
  colJugadores[indiceJugador][indicePosColManos - FIJO(1)][indiceManoJugador][indicePosColCartas - FIJO(0)][indiceCarta][indicePosImagen - FIJO(4)]

  Acceso a valorCartas:
  colJugadores[indiceJugador][indicePosColManos - FIJO(1)][indiceManoJugador][indicePosValorCartas - FIJO(1)]

  acceso a resultado:
  colJugadores[indiceJugador][indicePosColManos - FIJO(1)][indiceManoJugador][indicePosResultado - FIJO(6)]

*/
